import { motion } from "framer-motion";
import { RevealLineOnView } from "./RevealLine";

const CERAMIC_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_seven7h-detail/artifacts/9yyrf1ar_KZpPqVQQ-YoVCVDGwzfC2-ZyB_IlSrlL.jpg";

const stats = [
  { n: "10H", label: "Hardness Rating" },
  { n: "05Y", label: "Coverage" },
  { n: "07D", label: "Open per Week" },
  { n: "1250", label: "Ceramic · AUD" },
];

export default function CeramicSpotlight({ onBook }) {
  return (
    <section className="py-28 md:py-40 bg-[#050505]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center">
        <div className="md:col-span-5 order-2 md:order-1">
          <p className="eyebrow mb-6">
            <RevealLineOnView>Spotlight — Ceramic Coating</RevealLineOnView>
          </p>
          <h2 className="font-serif text-5xl md:text-7xl font-light text-white leading-[0.95] mb-8">
            <RevealLineOnView>The last coat</RevealLineOnView>
            <RevealLineOnView delay={0.06} className="italic text-neutral-400">
              your car will need.
            </RevealLineOnView>
          </h2>
          <p className="text-neutral-400 leading-relaxed max-w-md mb-10">
            Nano-graphene ceramic layer bonded to paint, glass, metal and
            plastic. A 10H hardness rating shields against UV, water spots, small
            rock chips and swirl marks — for up to five years of showroom gloss.
          </p>

          <div className="grid grid-cols-4 gap-4 mb-10">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
              >
                <div className="font-serif text-2xl md:text-4xl text-white leading-tight">
                  {s.n}
                </div>
                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-neutral-500 mt-1">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>

          <button onClick={onBook} className="btn-primary" data-testid="ceramic-book-btn">
            Reserve Ceramic Slot
          </button>
        </div>

        <div className="md:col-span-6 md:col-start-7 order-1 md:order-2 relative">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="aspect-[4/5] overflow-hidden bg-black"
          >
            <img
              src={CERAMIC_IMG}
              alt="Ceramic coating on a dark vehicle body under studio lights"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </motion.div>
          <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 vertical-rl font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-500 hidden md:block">
            SEVEN7H · Ceramic · Nano-Graphene
          </div>
        </div>
      </div>
    </section>
  );
}
